module.exports = __webpack_public_path__ + "img/EP1000_model.52f48f31.png";